import { combineReducers } from "redux"
import { reducer as plansReducer } from "./plans"
import { reducer as loaderReducer } from "./loader"
import { connectRouter } from "connected-react-router"
import { reducer as notificationReducer } from "./notification"
import { reducer as calendarViewReducer } from "./calendarView"
import { reducer as carOrderReducer } from "./carOrder"
import { reducer as visibilityReducer } from "./visibility"
import { reducer as resequenceReducer } from "./resequence"
import { reducer as dashboardReducer } from "./dashboard"
import { reducer as userProfileReducer } from "./userProfile"
import { reducer as userViewsReducer } from "./userViews"
import { reducer as chargeManagementReducer } from "./chargeManagement"
import { reducer as generalPlacementsReducer } from "./generalPlacements"
import { reducer as emailNotificationsReducer } from "./emailNotifications"
import { reducer as errorReducer } from "./error"
import { reducer as switchRequestsReducer } from "./switchRequests"
import { reducer as configReducer } from "./config"

const rootReducer = (history) =>
    combineReducers({
        router: connectRouter(history),
        plans: plansReducer,
        carOrder: carOrderReducer,
        resequence: resequenceReducer,
        loader: loaderReducer,
        notification: notificationReducer,
        calendarView: calendarViewReducer,
        visibility: visibilityReducer,
        dashboard: dashboardReducer,
        userProfile: userProfileReducer,
        userViews: userViewsReducer,
        chargeManagement: chargeManagementReducer,
        generalPlacements: generalPlacementsReducer,
        emailNotifications: emailNotificationsReducer,
        error: errorReducer,
        switchRequests: switchRequestsReducer,
        config: configReducer,
    })

export default rootReducer
